import React from "react";
import _ from "lodash";
import { FormStatus } from 'utils/constants/form-constants';
import MutateEmployeeRights from "utils/mutate/employee-rights";
import SearchSelectUserComponent from 'components/management/molecules/SearchSelectUserComponent'

const ManagementBuildingsComponentsEmployeeScene = ({ addedAvailableForEmployees = [], readonly, onSubmit, building, floor, room }) => {

	return (
		<SearchSelectUserComponent
			selectedEmployees={ addedAvailableForEmployees }
			readonly={ readonly }
			onSubmit={ ( guids, { callback } ) => {
				MutateEmployeeRights.mutate(
					_.get( building, 'guid', null ),
					_.get( floor, 'guid', null ),
					_.get( room, 'guid', null ),
					guids,
					{
						callbackStart: callback.bind( this, FormStatus.LOADING ),
						callbackError: callback.bind( this, FormStatus.ERROR ),
						callbackSuccess: (result) => {
							callback( FormStatus.SUCCESS );
							setTimeout( () => {
								return callback(FormStatus.NONE);
							}, 2000 );
							
							if( _.isFunction( onSubmit ) ) {
								onSubmit();
							}
						},
						
					}
				)
			}}
		/>
	)
}

export default ManagementBuildingsComponentsEmployeeScene
